import { SchedulerTaskSubTaskSimple } from './scheduler-task-subtask-simple';

export const CREATED = 1;
export const PREPARING = 2;
export const READY = 3;
export const FAIL = 4;
export const ISSUES = 5;
export const RUNNING = 6;

export class SchedulerTaskWithModelTimeLineSimple {

  public position: number;
  public duration: number;
  public formatedDuration: number;
  public taskDuration: number;
  public durationPutAdditionalTime: number;
  public durationRemoveAdditionalTime: number;

  constructor(
    public hash?: string,
    public schedulerTaskVersionHash?: string,
    public modelHash?: string,
    public startDate?: number,
    public endDate?: number,
    public status?: number,
    public deviation?: number,
    public current?: boolean,
    public finished?: boolean,
    public started?: boolean,
    public isPendingProgramDefinition?: boolean,
    public putAdditionalTimes?: number,
    public removeAdditionalTimes?: number,
    public programDefinition?: string,
    public manufacturingOrderCode?: string,
    public manufacturingOrderHash?: string,
    public manufacturingOrderIsClaimed?: boolean,
    public operationCode?: string,
    public hasMaterialReady?: boolean,
    public hasMaterialInStock?: boolean,
    public mpReady?: string,
    public subTasks?: SchedulerTaskSubTaskSimple[]
  ) { }

  get progressDuration() {
    return this.endDate - this.startDate;
  }

  get isPreparing() {
    return this.status === PREPARING;
  }

  get isFail() {
    return this.status === FAIL;
  }

  get isIssues() {
    return this.status === ISSUES;
  }

  get isReady() {
    return this.status === READY;
  }

  get isRunning() {
    return this.status === RUNNING;
  }

  get code () {
    return (this.manufacturingOrderCode && this.operationCode) ? `${this.manufacturingOrderCode} - ${this.operationCode}` :
      this.manufacturingOrderCode ? this.manufacturingOrderCode : '-';
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-with-model-timeline-simple.ts